<div *ngIf="ms.showAdviseBanner" class="advise-banner in-out">
    <p><b>{{ ms.saveAdvise ? 'guardado' : '' }} {{ ms.advType }}</b></p>
</div>